export const Tabs = {
    SEARCH: 'srch',
    MYBOT: 'mB',
    ASSIST: 'ast',
    TRANSCRIPT: 'trnspt',
    HISTORY: 'HISTORY',
    SETTINGS: 'SETTINGS',
    CHECKLIST : 'cl',
    SMARTASSIST_SOURCE: 'SMARTASSIST_SOURCE',
    CUSTOM_TAB : 'cst',
    MORE : 'mR'
};

export const RenderResponseType = {
    SUGGESTIONS : 'SUGGESTIONS',
    SMALLTALK : 'SMALLTALK',
    AUTOMATION : 'AUTOMATION',
    AUTOMATION_NODE : 'AUTOMATION_NODE',
    USERMSG : 'USERMSG',
    ASSISTRESPONSE : 'ASSISTRESPONSE',
    FEEDBACK : 'FEEDBACK',
    WELCOME_MSG : 'WELCOME_MSG',
    INITIAL_DIALOG : 'INITIAL_DIALOG',
    MSG_NODE : 'TELLCUSTOMER',
    ENTITY_NODE : 'ASKCUSTOMER',
    AUTOMATION_START : 'AUTOMATION_START',
    AUTOMATION_END : 'AUTOMATION_END'
}

export const ProjConstants = {
    ASSIST : 'Assist',
    MYBOT : 'My Bot',
    CUSTOM : 'Custom',
    TRANSCRIPT : "Transcript",
    LIBRARY : 'Library',
    SETTINGS : 'Settings',
    SEARCH : 'Search',
    PLAYBOOK: 'Playbook',
    VOICE : 'voice',
    CHAT : 'chat',
    BOTID : 'botId',
    CONVESATIONID : 'conversationId',
    RUN : 'RUN',
    AGENTASSIST_RUN : 'Run with Agent Inputs',
    SEND : 'Send',
    COPY : 'Copy',
    COPIED : 'COPIED',
    SHOW_MORE : 'Show more',
    SHOW_LESS : 'Show less',
    READ_MORE : 'More',
    READ_LESS : 'Less',
    EXPAND : 'Expand',
    READ_MORE_EXPAND : 'Read more | Expand',
    CLOSE : 'Close',
    DIALOG : 'Dialog task',
    FAQ : 'FAQ',
    ARTICLE : 'Article',
    SNIPPET : 'Snippet',
    VIEW_ALL_FAQ : 'View All FAQs',
    VIEW_FEW_FAQ : 'View Few FAQs',
    VIEW_ALL_ARTICLES : 'View All Articles',
    VIEW_FEW_ARTICLES : 'View Few Articles',
    VIEW_ALL_SNIPPETS : 'View All Snippets',
    VIEW_FEW_SNIPPETS : 'View Few Snippets',
    SENDMSG : 'agentAssist.SendMessage',
    COPYMSG : 'agentAssist.CopyMessage',
    SEND_METHOD : 'send',
    COPY_METHOD : 'copy',
    AWAITING : 'Awaiting Response  |  Type to continue',
    OVERRIDE : 'Type to continue',
    ACCEPT_RESPONSE : 'Response Accepted',
    AGENT_ENTERED : 'Agent Entered',
    WIDGET_LOADER : 'widget',
    INDIVIDUAL_LOADER : 'individual',
    LOGO_PATH : 'assets/images/logo/koreLogo.svg',
    DOCUMENTATION_LINK : 'https://docs.kore.ai/agentassist/',
    FAQ_LINK : 'https://docs.kore.ai/agentassist/frequently-asked-questions/faq/',
    KOREACADEMY_LINK : 'https://academy.kore.ai/',
    WRONG_SUGGESTION : "Wrong suggestions",
    INCORRECT_INTENT : "Incorrect intent",
    ACCIDENTAL_CLICK : "Accidental click",
    TIME_TAKING : "Time taking",
    OTHER : "Other",
    SETTINGS_DOCUMENTATION : "documentation",
    SETTINGS_FAQ : "faq",
    SETTINGS_KOREACADEMY : "koreAcademy",
    SUGGESTION_LINEHEIGHT : 18,
    SUGGESTION_ADDHEIGHT : 10,
    SUGGESTION_MAXHEIGHT : 12,
    DISCARD_ALL : 'discard all',
    INTERRUPT : 'Interrupt',
    INCOMING : 'incoming',
    OUTGOING : 'outgoing'
}

export const coachingConst: any = {
  NUDGE_DATA: {
      positive: {
          color: '#22C55E',
          icon: 'krIocnsFont-thumbs-up'
      },
      neutral: {
          color: '#E5E5E5',
          className : 'info-nudge'
      },
      alert: {
          color: '#F59E0B',
          icon: 'krIocnsFont-alert-triangle',
          className : 'warning-nudge'
      },
      critical: {
          color: '#EF4444',
          icon: 'krIocnsFont-hand',
          className : 'danger-nudge'
      }
  },

  HINT_DATA: {
      positive: {
          color: '#22C55E',
          icon: 'krIocnsFont-thumbs-up'
      },
      neutral: {
          color: '#E5E5E5',
          icon : 'krIocnsFont-exclamation',
          className : 'info-hint'
      },
      alert: {
          color: '#F59E0B',
          icon : 'krIocnsFont-alert-triangle',
          className: 'warning-hint',
      },
      critical: {
          color: '#EF4444',
          icon : 'krIocnsFont-hand',
          className: 'danger-hint'
      }
  }
}

  export const serviceTabMap : any = {
    "ast": Tabs.ASSIST,
    "srch": Tabs.SEARCH,
    "trnspt": Tabs.TRANSCRIPT,
    "mB": Tabs.MYBOT,
    "cl" : Tabs.CHECKLIST,
    "cst" : Tabs.CUSTOM_TAB
}

export const PlaybookColorMap : any = {
    '#0BA5EC': '#F0F9FF',
    '#06AED4': '#ECFDFF',
    '#2E90FA': '#EFF4FF',
    '#6172F3': '#EEF4FF',
    '#6172F3f': '#F5F3FF',
    '#EE46BC': '#FDF4FF',
    '#F63D68': '#FFF1F3',
    '#669F2A': '#F5FBEE',
    '#16B364': '#EDFCF2',
    '#FF4405': '#FFF4ED'
}

export const storageConst : any = {
    CURRENT_TAB : 'aa-currentTab',
    AGENT_ASSIST_STATE : 'agentAssistState',
    ASSIST_INTERRUPT_DIALOG_LIST : 'aa-assistInterruptList',
    MYBOT_INTERRUPT_DIALOG_LIST : 'aa-mybotInterruptList',
    PROACTIVE_MODE : 'aa-proactiveMode',
    LANGUAGE : 'aa-lang',
    THEME : 'aa-theme',
    ACTIVE_TAB : 'aa-activeTab',
    AUTOSCROLL : 'aa-autoScroll',
    INTERNAL_TRANSFER : 'aa-internalTransfer',
    ENGLISH : 'en',
    LIGHT : 'light',
    DARK : 'dark',
    FINAL_SUMMARY_GENERATED : 'aa-finalSummaryGenerated'
}

export const DARKTHEME_COLORCODES = {
    primay:'#2970ff',
    secondary:'#101828',
    primaryText:'#fcfcfd',
    secondaryText:'#FFF',
    bodyBackground:'#1d2939',
    warningColor:'#D92D20',
}

export const SENTI_POLARITY_MAP : any = {
    1 : -2,
    2 : -1,
    3 : -1,
    4 : 0,
    5 : 0,
    6 : 0,
    7 : 1,
    8 : 1,
    9 : 2,
    10 : 2
}

export const POLARITY_VS_STYLES : any = {
    'positive' : {
        className : 'positive-title',
        icon : 'ast-thumbup',
        emoji : '&#x1F604;'
    },
    'neutral' : {
        className : 'neutral-title',
        icon : 'ast-thumbup',
        emoji : '&#x1F610;'
    },
    'negative' : {
        className : 'negative-title',
        icon : 'ast-thumbdown',
        emoji : '&#x1F641;'
    }
}

export const ClassMapConstanst = {
    "HEADER" : '.aa-header',
    "FOOTER" : '.aa-footer',
    "FOOTER_BTN" : '.aa-footer-btn-',
    "FOOTER_BTN_SEARCH" : '.aa-footer-btn-srch',
    "FOOTER_BTN_MYBOT" : '.aa-footer-btn-mB',
    "FOOTER_BTN_ASSIST" : '.aa-footer-btn-ast',
    "FOOTER_BTN_TRANSCRIPT" : '.aa-footer-btn-trnspt',
    "ASSIST_SECTION" : '.aa-assist-section',
    "SUGGESTION_EACH" :'.aa-each-suggestion',
    "SUGGESTION_EACH_HEADER" : '.aa-suggestion-header',
    "SUGGESTION_EACH_TITLE" : '.aa-suggestion-title',
    "SUGGESTION_EACH_BODY" : '.aa-each-suggestion-faq-body',
    "SUGGESTION_LESS_LINK" : '.aa-less-link',
    "SUGGESTION_MORE_LINK" : '.aa-more-link',
    "SUGGESTION_SEND_BTN" : '.aa-send-btn-suggestion',
    "SUGGESTION_COPY_BTN" : '.aa-copy-btn-suggestion',
    "SUGGESTION_SENDCPY_ACTION" : '.aa-action-buttons',
    "SUGGESTION_FAQ_UP_ARROW" : '.aa-faq-up-arrow',
    "SUGGESTION_FAQ_DOWN_ARROW" : '.aa-faq-down-arrow',
    "SUGGESTION_FAQ_EXPAND" : '.aa-expand-btn-link',
    "SUGGESTION_FAQ_CLOSE" : '.aa-close-btn-link',
    "SUGGESTION_FAQ_ANS_LENGTH" : '.aa-faq-ans-length',
    "SUGGESTION_FAQ_ANS_LOADER" : '.aa-faq-answer-loader',
    "SUGGESTION_SNIPPET_SOURCE_TAG" : '.aa-source-tag',
    "SUGGESTION_SNIPPET_LINK" : '.aa-snippet-link',
    "SUGGESTION_ARTICLE_LINK" : '.aa-article-link',
    "SUGGESTION_FILE_LINK" : '.aa-file-link',
    "SEARCH_INPUT_BLOCK" : '.aa-input-block',
    "SEARCH_INPUT_CLOSE" : '.aa-input-search-close',
    "SEARCH_INPUT_ICON" : '.aa-input-search-icon',
    "SUGGESTION_SENT_TEXT" : '.aa-sent-text',
    "SEARCH_SUGGESTION_WRAPPER" : '.aa-search-suggestion-wrapper',
    "HIDE_ELEMENT" : 'aa-hidden',
    "SDK_MAIN_WRAPPER" : 'agentassist-widget-main-chat-container-wrapper',
    "NUDGE_TEMPLATE" : 'aa-nudges-template-data',
    "NUDGE_CLOSE" : 'aa-close-nudge',
    "HINT_CLOSE" : 'aa-close-hint',
    "ACKTEXT_CLOSE" : 'aa-ackText-close',
    "HINT_TEMPLATE" : 'aa-hints-template-data',
    "SEND_TEXT" : '.aa-sent-text',
    "SCROLL_DATA_ASSIST": 'scroll-data-assist',
    'DESC_TEXT_SUGGESTION' : '.suggestion-paragraph',
    'DESC_TEXT_SNIPPET_EXTERNAL' : '.aa-snippet-content-ref1',
    'DESC_TEXT_SNIPPET_INTERNAL' : '.aa-snippet-content-ref2',
    'MORE_BTN_CONTAINER' : '.aa-seemore-buttons',
    'EXTERNAL_SNIPPET_MORE_BTN_CONTAINER' : '.aa-external-seemore-buttons',
    'INTERNAL_SNIPPET_MORE_BTN_CONTAINER' : '.aa-internal-seemore-buttons',
    'MORE_BUTTON' : '.aa-more-button',
    'SUGGESTION_EXPANDED' : 'expanded',
    'TRANSCRIPT_BODY_WRAPPER' : 'aa-transcript-body-wrapper',
    'HISTORY_TRANSCRIPT_BODY_WRAPPER' : 'aa-history-transcript-body-wrapper',
    'TRANSCRIPT_WRAPPER' : 'aa-transcript-wrapper',
    'TRIGGER_CHECKLIST_BULB_COUNT' : '.aa-triggerDynChecklist-bulb-count',
    'TRIGGER_CHECKLIST_BTN' : '.aa-trigger-checklist-btn-',
    'TRIGGER_CHECKLIST_NAME' : '.aa-trigger-checklist-name',
    'TRIGGER_CHECKLIST_STEPCOUNT' : '.aa-trigger-checklist-stepcount',
    'TRIGGET_CHECKLIST_DROPDOWN' : '.aa-trigger-checklist-drp',
    'TRIGGER_CHECKLIST_DROPDOWN_WRAPPER' : '.aa-triggerList-drp-wrapper',
    'CHECKLIST_DROPDOWN_WRAPPER' : '.aa-checklist-drp-wrapper',
    'CHECKLIST_DROPDOWN' : '.aa-checklist-drp',
    'PRIMARY_SCRIPTS' : '.aa-primary-scripts',
    'DYNAMIC_SCRIPTS' : '.aa-dynamic-scripts',
    'SELECTED_CHECKLIST' : '.aa-selected-checklist',
    'SELECTED_CHECKLIST_ARROW' : '.aa-selected-checklist-arrow',
    'STAGE_DRP_WRAPPER_MAIN' : '.aa-stage-drp-wrapper-main',
    'STAGE_DRP_WRAPPER' : '.aa-stage-drp-wrapper',
    "SELECTED_STAGE" : '.aa-selected-stage',
    "SELECTED_STAGE_ARROW" : '.aa-selected-stage-arrow',
    "STAGE_DROPDOWN" : '.aa-stage-drp',
    "STEP_COMPLETE_COUNT" : '.aa-step-complete-count',
    "PROCEEDTOCLOSE_BTN" : '.aa-proceedtoclose-btn',
    "PRIMARY_CHECKLIST_BTN" : '.aa-primary-cl-',
    "PRIMARY_CHECKLIST_RESUME_BTN" : '.aa-primary-cl-resume-',
    "DYNAMIC_CHECKLIST_BTN" : '.aa-dynamic-cl-',
    "DYNAMIC_CHECKLIST_RESUME_BTN" : '.aa-dynamic-cl-resume-',
    "CHECKLIST_HEADER" : '.aa-playbook-header',
    "CHECKLIST_HEADER_STEP" : '.aa-heading-step',
    "CHECKLIST_HEADER_STEP_NAME" : '.aa-step-header-name',
    "CHECKLIST_EACH_STEP" : '.aa-playbook-step-',
    "CHECKLIST_DISABLE_MSG" : 'disabled-msg',
    "CHECKLIST_STRIKE" : 'strike-text',
    "CHECKLIST_STEP_COMPLETE_BTN" : '.aa-step-complete-',
    "CHECKLIST_STEP_SEND_BLOCK" : '.step-text-send-block',
    "CHECKLIST_STEP_ONGOING" : 'playbook-step-ongoing',
    "CHECKLIST_STEP_COPY_BTN" : '.aa-step-copy-btn',
    "CHECKLIST_STEP_SEND_BTN" : '.aa-step-send-btn',
    "CHECKLIST_STEP_CONFIRMATION_BTN" : '.aa-step-confirmation-btn-',
    "CHECKLIST_CLOSE_STEPS" : '.aa-close-steps',
    "CHECKLIST_CLOSE_STAGE" : '.aa-close-stage',
    "CHECKLIST_ITEM_CHECK" : '.aa-cl-check-',
    "CHECKLIST_EACH_ITEM" : '.aa-cl-item',
    "CHECKLIST_EACH_RESUME" : '.aa-cl-resume-',
    "CHECKLIST_CLOSE_STAGE_BTN" : '.aa-close-stage-btn',
    "CHECKLIST_EACH_STAGE_DRP_ITEM" : '.aa-stage-drp-',
    "CHECKLIST_SELECTED_STAGE_CHECK" : '.aa-selected-stage-',
    "CHECKLIST_EMPTY" : '.aa-checklist-empty',
    "TRIGGER_CHECKLIST_COUNT_BTN" : '.aa-trigger-checklist-count-btn',
    "SEARCH_MENU_WRAPPER" : '.aa-search-menu-wrapper',
    "DIALOG_RUN_BTN" : '.aa-dialog-run-',
    "DIALOG_AGENT_RUN_WRAPPER" : '.aa-dialog-agent-run-wrapper-',
    "DIALOG_AGENT_RUN_ELIPSE_BTN" : '.aa-dialog-agent-run-elipse-',
    "DIALOG_AGENT_RUN_DROPDOWN" : '.aa-dialog-agent-run-dropdown-',
    "DIALOG_AGENT_RUN_BTN" : '.aa-dialog-agent-run-',
    "ASSIST_INTERRUPT_WRAPPER" : '.aa-assist-interrupt-wrapper',
    "ASSIST_INTERRUPT_DROPDOWN_WRAPPER" : '.aa-assist-interrupt-dropdown-wrapper',
    "ASSIST_INTERRUPT_TOGGLE_BTN" : '.aa-assist-interrupt-toggle',
    "ASSIST_INTERRUPT_DROPDOWN_CONTENT" : '.aa-assist-interrupt-dropdown-content',
    "ASSIST_INTERRUPT_COUNT" : '.aa-interrupt-length',
    "ASSIST_HEADER_SECTIONS" : '.aa-assist-header-section',
    "ASSIST_LISTVIEW_BUTTON" : '.aa-assist-listview-btn',
    "ASSIST_RESTART_BUTTON" : '.aa-assist-restart-btn',
    "ASSIST_TERMINATE_BUTTON" : '.aa-assist-terminate-btn',
    "TERMIANTE_POPUP" : '.aa-assist-terminate-popup',
    "TERMINATE_CLOSE_BTN" : '.aa-terminate-close-btn',
    "TERMINATE_CANCEL_BTN" : '.aa-terminate-cancel-btn',
    "TERMINATE_YES_BTN" : '.aa-terminate-yes-btn',
    "TERMINATE_OVERRIDE_BTN" : '.aa-terminate_override-btn',
    "INTERRUPT_POPUP" : '.aa-assist-interrupt-popup',
    "INTERRUPT_CLOSE_BTN" : '.aa-interrupt-close-btn',
    "INTERRUPT_CANCE_BTN" : '.aa-interrupt-cancel-btn',
    "INTERRUPT_ACCEPT_BTN" : '.aa-interrupt-accept-btn',
    "INTERRUPT_RUNLATER_BTN" : '.aa-interrupt-run-later',
    "INTERRUPT_DIALOG" :  '.interrupt-dialog-',
    "ASSIST_HEADER_DIALOG_WRAPPER" : '.aa-assist-header-dialog-wrapper',
    "ASSIST_HEADER_DIALOG_NAME" : '.aa-assist-header-dialog-name',
    "ASSIST_HEADER_ENTITY_NAME" : '.aa-assist-header-entity-name',
    "DIALOG_WRAPPER" : '.aa-dialog-wrapper-',
    "FEEDBACK_WRAPPER" : '.aa-feedback-wrapper-',
    "FEEDBACK_HELPFUL_SECTION" : '.helpful-feedback-section-',
    "DIALOG_START" : '.aa-dialog-start-',
    "DIALOG_END" : '.aa-dialog-end-',
    "ASSIST_EMPTY_SCREEN" : '.aa-assist-empty',
    "NODE_BODY" : '.aa-node-body',
    "NODE_SEND_TEXT" : '.aa-sent-text',
    "WELCOME_MSG_NODE" : '.aa-welcome-msg-',
    "WELCOME_NODES" : '.aa-welcome-msg-node',
    "ENTITY_AGENT_ICON" : '.aa-entity-agent-icon',
    "ENTITY_ERROR_BTN" : '.aa-entity-error-btn',
    "ENTITY_ERROR_COUNT" : '.aa-entity-error-count',
    "ENTITY_REMOVE_BTN" : '.aa-entity-remove-btn',
    "ENTITY_CHECK_BTN" : '.aa-entity-check-btn',
    "ENTITY_OVERRIDE_BTN" : '.aa-entity-override-btn',
    "ENTITY_INPUT" : '.aa-entity-input',
    "ENTITY_ERROR_RESPONSE" : '.error-no-reponse',
    "AGENTASSIST_DISABLED_MSG" : 'disabled-msg',
    "ENTITY_ACTIONS" : '.aa-entity-actions',
    "TELL_CUST_NODE" : '.aa-tell-customer-node-',
    "ASK_CUST_NODE" : '.aa-ask-customer-node-',
    "FEEDBACK_POSITIVE" : '.aa-feedback-positive',
    "FEEDBACK_NEGATIVE" : '.aa-feedback-negative',
    "FEEDBACK_NEGATIVE_DROPDOWN_BTN" : '.aa-negative-feedback-dropdown-btn',
    "FEEDBACK_NEGATIVE_BOX" : '.aa-negative-feedback-box',
    "FEEDBACK_ACTIVE_BUTTON" : 'active-feedback-btn',
    "FEEDBACK_ROTATE_BTN" : 'active-feedback-btn-rotate',
    "FEEDBACK_NEGATIVE_SUGGESTION_SELECTION" : 'active-improve-btn',
    "FEEDBACK_SUGGESTION" : '.feedback-suggestion-',
    "FEEDBACK_SUBMIT" : '.aa-feedback-submit',
    "FEEDBACK_COMMENT_COUNT" : '.aa-feedback-comment-count',
    "FEEDBACK_COMMENT" : '.aa-feeback-comment-',
    "FEEDBACK_TOASTR" : '.aa-feedback-toastr',
    "FEEDBACK_CLOSE_BTN" : '.aa-feedback-close-btn',
    "ENTITY_MSG_BODY" : '.aa-entity-msg-body',
    "LIST_VIEW_POPUP" : '.aa-assist-listview-popup',
    "LIST_VIEW_CLOSE_BTN" : '.aa-listview-close-btn',
    "LIST_VIEW_BODY" : '.aa-listview-body',
    "ENTITY_NODE" : '.aa-entity-node',
    "ENTITY_HEADER" : '.ask-cust-node',
    "ENTITY_ERROR_OVERRIDE_TEXT" : '.aa-error-override-text',
    "ENTITY_ERROR_MESSAGE" : '.aa-entity-error-msg',
    "ENTITY_ATTACHMENT_DIV" : '.aa-entity-attachment-div',
    "ENTITY_CHOOSE_FILE" : '.aa-entity-choose-file',
    "ENTITY_DISPLAY_NAME" : '.aa-entity-displayname',
    "INPUT_ATTACHMENT" : 'attachment-input',
    "ENTITY_OVERRIDE_MSG" : '.aa-override-msg',
    "ENTITY_ATTACHMENT_LARGE_FILE_MSG" : '.aa-large-file-msg',
    "ENTITY_ATTACHMENT_VIEW" : '.aa-entity-attachment-view',
    "TRANSCRIPT_BULB_COUNT" : '.aa-transcript-bulb-count',
    "TRANSCRIPT_BULB" : '.aa-transcript-bulb-',
    "TRANSCRIPT_BUBBLE" : '.aa-transcript-bubble-',
    "ENTITY_ATTACHMENT_VIEW_MODAL" : '.aa-attachment-image-view',
    "ENTITY_ATTACHMENT_IMAGE" : '.aa-attachment-img',
    "ENTITY_ATTACHMENT_BACK_BTN" : '.aa-attachment-back-btn',
    "ENTITY_ATTACHMENT_CLOSE_BTN" : '.aa-attachment-close-btn',
    "INTERRUPT_CURRENT_DIALOG" : '.aa-current-dialog',
    "MYBOT_INTERRUPT_WRAPPER" : '.aa-mybot-interrupt-wrapper',
    "MYBOT_INTERRUPT_DROPDOWN_WRAPPER" : '.aa-mybot-interrupt-dropdown-wrapper',
    "MYBOT_INTERRUPT_TOGGLE_BTN" : '.aa-mybot-interrupt-toggle',
    "MYBOT_INTERRUPT_DROPDOWN_CONTENT" : '.aa-mybot-interrupt-dropdown-content',
    "MYBOT_INTERRUPT_COUNT" : '.aa-mybot-interrupt-length',
    "MYBOT_HEADER_SECTIONS" : '.aa-mybot-header-section',
    "MYBOT_SECTION" : '.aa-mybot-section',
    "MYBOT_EMPTY_SCREEN" : '.aa-mybot-empty',
    "MYBOT_HEADER_DIALOG_WRAPPER" : '.aa-mybot-header-dialog-wrapper',
    "MYBOT_HEADER_DIALOG_NAME" : '.aa-mybot-header-dialog-name',
    "MYBOT_HEADER_ENTITY_NAME" : '.aa-mybot-header-entity-name',
    "MYBOT_LISTVIEW_BUTTON" : '.aa-mybot-listview-btn',
    "MYBOT_RESTART_BUTTON" : '.aa-mybot-restart-btn',
    "MYBOT_TERMINATE_BUTTON" : '.aa-mybot-terminate-btn',
    "DISABLED" : 'disabled',
    "ASSIST_SCROLL_WRAPPER" : '.aa-assist-scroll-wrapper',
    "ASSIST_UP_ARROW" : 'aa-assist-up-arrow',
    "ASSIST_DOWN_ARROW" : 'aa-assist-down-arrow',
    "MYBOT_UP_ARROW" : 'aa-mybot-up-arrow',
    "MYBOT_DOWN_ARROW" : 'aa-mybot-down-arrow',
    "CUSTOM_TAB_UP_ARROW" : 'aa-custom-tab-up-arrow',
    "CUSTOM_TAB_DOWN_ARROW" : 'aa-custom-tab-down-arrow',
    "NETWORK_ERROR_TOASTR" : 'aa-network-error-toastr',
    "NETWORK_ERROR_CLOSE_BTN" : 'aa-network-error-close-btn',
    "SETTINGS_POPUP" : '.aa-settings-popup',
    "SETTINGS_CLOSE_BTN" : '.aa-settings-close-btn',
    "SETTINGS_POPUP_BACK_BTN" : '.aa-settings-popup-back-btn',
    "SETTINGS_POPUP_CLOSE_BTN" : '.aa-settings-popup-close-btn',
    "SETTINGS_HELP_BTN" : '.aa-settings-help-btn',
    "SETTINGS_NEXT_BTN" : '.aa-settings-next-btn',
    "SETTINGS_HELP_GROUP" : '.aa-settings-help-group',
    "SETTINGS_HELP_SECTION" : '.aa-settings-help-section',
    "SETTINGS_MAIN_SECTION" : '.aa-settings-main-section',
    "SETTINGS_AUTO_SCROLL" : '.aa-settings-auto-scroll',
    "SETTINGS_FAQ_LINK" : '.aa-settings-faq-link',
    "SETTINGS_KORE_ACADEMY_LINK" : '.aa-settings-koreacademy-link',
    "SETTINGS_DOCUMENTATION_LINK" : '.aa-settings-document-link',
    "WRONG_SUGGESTION_BTN" : '.wrong-suggestion-btn',
    "SENTIMENT_POPUP" : '.aa-sentiment-popup',
    "SENTIMENT_POPUP_WRAPPER" : '.aa-sentiment-popup-wrapper',
    "ASSIST_SUMMARY_BTN" : '.aa-assist-summary-btn',
    "SUMMARY_COUNT" : '.aa-summary-count',
    "SUMMARY_CONTENT_COLLAPSE" : '.aa-summary-content-collapse',
    "SUMMARY_PREVIOUS_BTN" : '.aa-previous-summary-btn',
    "SUMMARY_MINIMIZE_BTN" : '.aa-minimize-summary',
    "SUMMARY_REFRESH_BTN" : '.aa-summary-refresh-btn',
    "SUMMARY_COPY_BTN" : '.aa-summary-copy-btn',
    "SUMMARY_SUBMIT_BTN" : '.aa-summary-submit-btn',
    "SUMMARY_CLOSE_BTN" : '.aa-close-summary-text',
    "SUMMARY_CONTENT_AREA" : '.aa-summary-content-area',
    "SUMMARY_EDITED_TEXT" : '.aa-summary-text-input',
    "SUMMARY_DATE_TIME" : '.aa-summary-date-time',
    "SUMMARY_TEXT_INPUT_WRAPPER" : '.aa-summary-text-input-wrapper',
    "SUMMARY_CONVERSATION_SUMMARY" : '.aa-conversaion-summary-text',
    "SUMMARY_DELETE_BTN" : '.aa-delete-summary-text',
    "SUMMARY_ACCORDION_INTERIM" : '.aa-summary-accordion-interim',
    "PREV_SUMMARY_FEEDBACK_WRAPPER" : '.aa-prev-summary-',
    "FORM_FEEDBACK" : '.aa-form-feedback-info',
    "SUMMARY_ACTION_MINIMIZED" : '.aa-generate-summary-action-minimized',
    "SETTINGS_LANGUAGE_SECTION" : '.aa-settings-language-section',
    "SETTINGS_LANGUAGE_GROUP" : '.aa-settings-language-group',
    "SETTINGS_LANGUAGE_SELECT" : '.aa-language-item',
    "ENTITY_EXPAND_BTN" : '.aa-entity-expand-btn',
    "ENTITY_REDUCE_BTN" : '.aa-entity-reduce-btn',
    "CUSTOM_TAB_SECTION" : ".aa-custom-tab-section",
    "CUSTOM_TAB_HEADER_SECTION" : ".aa-custom-tab-header-section",
    "CUSTOM_TAB_INTERRUPT_WRAPPER" : ".aa-custom-tab-interrupt-wrapper",
    "CUSTOM_TAB_INTERRUPT_COUNT" : ".aa-custom-tab-interrupt-length",
    "CUSTOM_TAB_INTERRUPT_DROPDOWN_WRAPPER" : ".aa-custom-tab-interrupt-dropdown-wrapper",
    "CUSTOM_TAB_INTERRUPT_TOGGLE_BTN" : ".aa-custom-tab-interrupt-toggle",
    "CUSTOM_TAB_INTERRUPT_DROPDOWN_CONTENT" : ".aa-custom-tab-interrupt-dropdown-content",
    "CUSTOM_TAB_HEADER_DIALOG_WRAPPER" : ".aa-custom-tab-header-dialog-wrapper",
    "CUSTOM_TAB_HEADER_DIALOG_NAME" : ".aa-custom-tab-header-dialog-name",
    "CUSTOM_TAB_HEADER_ENTITY_NAME" : ".aa-custom-tab-header-entity-name",
    "CUSTOM_TAB_LISTVIEW_BTN" : ".aa-custom-tab-listview-btn",
    "CUSTOM_TAB_RESTART_BTN" : ".aa-custom-tab-restart-btn",
    "CUSTOM_TAB_TERMINATE_BTN" : ".aa-custom-tab-terminate-btn",
    "CUSTOM_TAB_EMPTY" : ".aa-custom-tab-empty",
    "CUSTOM_TAB_FOOTER_SECTION_RIGHT": ".aa-custom-tab-footer-section-right",
    "CUSTOM_TAB_FOOTER_SECTION": ".aa-custom-tab-footer-section",
    "CUSTOM_TAB_INTERRUPT_DIALOG_ITEM": ".aa-interrupt-dialog-custom-",
    "CUSTOM_TAB_DATA_WRAPPER_CONTAINER": ".aa-custom-tab-data-wrapper-container",
    "CUSTOM_TAB_SHOW_ALL_DIALOGS" : ".aa-custom-tab-show-all-dialogs",
    "CUSTOM_TAB_SHOW_ALL_DIALOGS_POPUP" : ".aa-custom-tab-show-all-dialogs-popup",
    "CUSTOM_TAB_POPUP_HEADER_CLOSE_BTN" : ".aa-custom-popup-header-close-btn",
    "CUSTOM_TAB_DIALOG_LIST_CONTAINER" : ".aa-custom-dialog-list-container",
    "MULTIPLE_OPTIONS_POPUP" : ".aa-multiple-options-popup",
    "OPTION_FEEDBACK" : ".aa-option-feedback",
    "FEEDBACK_POPUP_OVERLAY" : ".aa-feedback-popup-overlay",
    "POSITIVE_FEEDBACK_INFO" : ".aa-positive-feedback-info",
    "NEGATIVE_FEEDBACK_INFO" : ".aa-negative-feedback-info",
    "FEEDBACK_POPUP_CLOSE_BTN" : ".aa-feedback-popup-close-btn",
    "FEEDBACK_SUBMIT_BTN" : ".aa-widget-feedback-submit-btn",
    "FEEDBACK_SATISFIED_BTN" : ".aa-feedback-satisfied-btn",
    "FEEDBACK_UNSATISFIED_BTN" : ".aa-feedback-unsatisfied-btn",
    "FEEDBACK_POPUP_BODY" : ".aa-feedback-popup-body",
    "POSITIVE_FEEDBACK" : ".aa-positive-feedback",
    "NEGATIVE_FEEDBACK" : ".aa-negative-feedback",
    "POSITIVE_FEEDBACK_COMMENT" : ".aa-feeback-comment-positive",
    "NEGATIVE_FEEDBACK_COMMENT" : ".aa-feeback-comment-negative",
    "HINTS_WRAPPER_FIXED" : ".aa-hints-wrapper-fixed",
    "NUDGES_WRAPPER_FIXED" : ".aa-nudges-wrapper-fixed",
    "ASSIST_AGENTIC_HEADER_SECTIONS" : '.aa-assist-agentic-header-section',
    "ASSIST_AGENTIC_SECTION" : '.aa-assist-agentic-section',
    "ASSIST_AGENTIC_BLOCK_CONTENT" : '.aa-assist-agentic-block-content',
    "ASSIST_BLOCK_CONTENT" : '.ast-block-content',
    "ASSIST_HEADER_LEFT_SECTION" : '.assist-header-left-section',
    "ASSIST_HEADER_RIGHT_SECTION" : '.assist-header-right-section',
    "ASSIST_EMPTY_AGENTIC" : '.aa-assist-empty-agentic',
    "AGENTIC_INTERRUPT_OVERRIDE" : '.aa-agentic-interrupt-override-',
    "AGENTIC_NODE_WRAPPER" : '.aa-agentic-node-wrapper-',
    "AGENTIC_NODE_BODY_WRAPPER" : '.aa-agentic-node-body-wrapper-',
    "AGENTIC_NODE_CUST_INFO" : '.aa-agentic-cust-info-',
    "AGENTIC_NODE_REGENERATE_INPUT_WRAPPER" : '.aa-agentic-node-regenerate-input-wrapper-',
    "AGENTIC_NODE_REGENERATE_INPUT" : '.regenerate-input',
    "AGENTIC_NODE_REGENERATE_CANCEL_BTN" : '.aa-regenerate-cancel-btn',
    "AGENTIC_NODE_REGENERATE_SUBMIT_BTN" : '.aa-regenerate-submit-btn',
    "AGENTIC_NODE_OVERRIDE_INPUT_WRAPPER" : '.aa-agentic-override-input-wrapper-',
    "AGENTIC_COPILOT_NODE_WRAPPER" : '.aa-agentic-copilot-node-wrapper',
    "AGENTIC_INTERRUPT_BODY" : '.aa-agentic-interrupt-body-',
    "AGENTIC_THINKING_MSG" : '.aa-agentic-thinking-msg-',
    "AGENTIC_SEND_OR_COPY_ACTIONS" : '.aa-agentic-send-or-copy-actions',
    "AGENTIC_SEND_DYN_BTN" : '.aa-agentic-send-dyn-btn',
    "AGENTIC_COPY_BTN" : '.aa-agentic-copy-btn',
    "AGENTIC_SEND_BTN" : '.aa-agentic-send-btn',
    "AGENTIC_OVERRIDE_INPUT" : '.aa-agentic-override-input',
    "AGENTIC_OVERRIDE_CANCEL_BTN" : '.aa-agentic-override-cancel-btn',
    "AGENTIC_OVERRIDE_SUBMIT_BTN" : '.aa-agentic-override-submit-btn',
    "AGENTIC_OVERRIDE_TEXT" : '.aa-agentic-override-text',
    "AGENTIC_NODE_ANSWER" : '.aa-agentic-node-answer',
    "AGENTIC_COPILOT_NODE_BODY_WRAPPER" : '.aa-agentic-node-',
    "AGENTIC_PAUSE_AUTO_SEND_BTN" : '.aa-agentic-pause-auto-send-btn',
    "AGENTIC_DYNAMIC_SENDING_ACTION_BTN" : '.aa-dynamic-sending-action-btn',
    "AGENTIC_PAUSE_BTN" : '.aa-agentic-pause-btn',
    "AGENTIC_SENT_BTN" : ".aa-agentic-sent-btn",
    "AGENTIC_INPUT_OVERRIDE_CANCEL_BTN" : ".aa-input-override-cancel-btn",
    "AGENTIC_INPUT_OVERRIDE_SUBMIT_BTN" : ".aa-input-override-submit-btn",
    "AGENTIC_SENT_TEXT" : ".aa-agentic-sent-text",
    "AGENTIC_COPY_TEXT" : ".aa-agentic-copy-text",
    "AGENTIC_DYNAMIC_SEND_CLOSE_BTN" : ".aa-dynamic-send-close",
    "AGENTIC_SEND_TEXT" : ".aa-sent-text",
    "AGENTIC_PLAY_STATE" : ".aa-play-state",
    "AGENTIC_PAUSE_STATE" : ".aa-pause-state",
    "AGENTIC_DYNAMIC_SEND_ACTION_BTN_TEXT" : ".aa-dynamic-send-action-btn-text",
    "AGENTIC_COPILOT_MODE_WRAPPER" : ".agentic-copilot-mode-wrapper",
    "AGENTIC_SENT_COPY_ACTION" : ".aa-agentic-sent-copy-action",
}

export const IdMapConstant = {
    "PROACTIVE_BTN" : 'aa-proactiveBtn',
    "ASSIST_FAQ_SUGGESTION" : 'aa-faqSuggestion-',
    "ASSIST_SNIPPET_SUGGESTION" : 'aa-snippetSuggestion-',
    "ASSIST_ARTICLE_SUGGESTION" : 'aa-articleSuggestion-',
    "ASSIST_FILE_SUGGESTION" : 'aa-fileSuggestion-',
    "ASSIST_DIALOG_SUGGESTION" : 'aa-dialogSuggestion-',
    "SEARCH_DIALOG_SUGGESTION" : 'aa-dialogSuggestion',
    "SEARCH_FAQ_SUGGESTION" : 'aa-faqSuggestion',
    "SEARCH_SNIPPET_SUGGESTION" : 'aa-snippetSuggestion',
    "SEARCH_ARTICLE_SUGGESTION" : 'aa-articleSuggestion',
    "SEARCH_FILE_SUGGESTION" : 'aa-fileSuggestion',
    "SEARCH_INPUT" : 'aa-search-input',
    "SEARCH_SUGGESTION_BLOCK" : 'searchSuggestionsBlock',
    "SUMMARY_OVERLAY_BLOCK" : "section-agent-aa-wrapper",
    "CHECKLIST_MAIN_TEMPLATE" : "checkListMainTemplate",
    "CHECKLIST_BODY_TEMPLATE" : "checkListBodyTemplate",
    "TRIGGER_CHECKLIST_DRP" : "playbookDrpTriggerChecklist",
    "CHECKLIST_DRP_LIST_BTN" : "playbookDrpListBtn",
    "CHECKLIST_STAGE_DRP_BTN" : "playbookStageDrpBtn",
    "CHECKLIST_STEP_TEMPLATE" : "checklistStepTemplate",
    "ASSIST_SUGGESTIONS" : "assist-suggestions-",
    "LOADER_BLOCK_MAIN" : "aa-loader-main",
    "LOADER_BLOCK_INDIVIDUAL" : "aa-loader-individual",
    "SETTINGS_BTN" : "aa-settingsBtn",
    "DIALOG_SUGGESTION" : "dialog-suggestion-",
    "TOOLTIP_TRIGGER" : "tooltip-trigger-",
    "ASSIST_SECTION" : "assist-section",
    "SENTIMENT_BTN" : "sentimentBtn",
    "SENTIMENT_POPUP_CLOSE_BTN" : "sentiment-popup-close-btn",
    "DARK_THEME_BTN" : "aa-darkThemeBtn",
    "LIGHT_THEME_BTN" : "aa-lightThemeBtn",
    "SUMMARY_WRAPPER" : "aa-summary-wrapper-container",
    "CUSTOM_TAB_SEARCH_INPUT" : "aa-custom-dialog-search-input",
    "ASSIST_AGENTIC_SECTION" : "assist-agentic-section",
    "AGENTIC_SEARCH_RESULTS" : "agentic-search-results"
}
